import { createAction } from '@reduxjs/toolkit';

import { EventCardT } from '@/types/calendar';

export const calendarEventsKey = 'calendarEvents';

export interface CalendarEventsState {
    readonly queryString: string;
    readonly eventCards: EventCardT[];
    readonly eventCardSearchedIds: Array<{ event_id: string; score: number }>;
    readonly eventCardsDates: string[];
    readonly eventsLoading: boolean;
}

export enum CalendarEventsActionTypes {
    eventsLoad = 'calendarEvents/eventsLoad',
    eventsLoadSuccess = 'calendarEvents/eventsLoadSuccess',
    eventsClear = 'calendarEvents/eventsClear',

    eventsSearchLoad = 'calendarEvents/searchEventsLoad',
    eventsSearchLoadSuccess = 'calendarEvents/searchEventsLoadSuccess',
    eventsSearchReset = 'calendarEvents/searchEventsReset',

    eventLoadingStatusSet = 'calendarEvents/eventLoadingStatusSet',
}

export const eventLoadingStatusSet = createAction<boolean>(CalendarEventsActionTypes.eventLoadingStatusSet);

export const eventsLoad = createAction(CalendarEventsActionTypes.eventsLoad);
export const eventsSearchLoad = createAction<{ search_text: string; ranged: boolean }>(
    CalendarEventsActionTypes.eventsSearchLoad,
);
export const clearEvents = createAction(CalendarEventsActionTypes.eventsClear);
export const eventsSearchReset = createAction(CalendarEventsActionTypes.eventsSearchReset);
export const eventsSearchLoadSuccess = createAction<Array<{ event_id: string; score: number }>>(
    CalendarEventsActionTypes.eventsSearchLoadSuccess,
);
export type CalendarEventsActions =
    | ReturnType<typeof eventLoadingStatusSet>
    | ReturnType<typeof eventsLoad>
    | ReturnType<typeof eventsLoadSuccess>
    | ReturnType<typeof clearEvents>
    | ReturnType<typeof eventsSearchLoad>
    | ReturnType<typeof eventsSearchLoadSuccess>
    | ReturnType<typeof eventsSearchReset>;

export const eventsLoadSuccess = createAction<EventCardT[]>(CalendarEventsActionTypes.eventsLoadSuccess);
